export default {
  data () {
    return {
      window: {
        width: 0,
        height: 0
      },
      showFallenJackpots: false,
      fallenJackpots: {
        showSlider: '',
        ticketNo: 0,
        ticketLocation: '',
        jackpotAmount: ''
      },
      panelEvents: {},
      activeEvent: null,
      disabledBettingTime: 0,
      isBettingEnabled: true,
      secondsToStart: 180,
      roundLength: 0,
      showMatchResult: false,
      showSlider: true,
      showSideMenuMobile: true,
      upcomingMatch: {},
      videoResult: {},
      videoSeek: 0,
      videoList: [],
      videoListTemp: [],
      metaDataVideoList: [],
      metaDataVideoListTemp: [],
      showModal: false,
      showConnectionErrorModal: false,
      fullScreenActive: false,
      mobileDevice: false,
      config: null,
      jwplayerloaded: false,
      showLeftMenu: false,
      headerResultShow: false,
      headerResult: {
        HomeScore: 0,
        AwayScore: 0
      },
      scaleHeader: false,
      showBettingHistory: false,
      mainPageScrollYPosition: 0,
      currentGame: null,
      showMenuHeader: true,
      tmpCurrentGameResultHeight: [],
      tmpFullScreen: false,
      openConfirmModal: false,
      waitingForRoundLength: false,
      tempData: [],
      elementAside: null,
      totalVideoLength: 0
    }
  }
}
